﻿import { bindable, customElement, PLATFORM, useView } from 'aurelia-framework';

@customElement('message')
@useView(PLATFORM.moduleName('./message.html'))
export class Message {
  @bindable
  icon: string;

  @bindable
  iconSize: string = '4rem';

  @bindable
  colour: string;
}
